import React, { useState, useEffect } from "react";

// CSS file for custom styles
import "./Mid-section-Mobile.scss";

//import components
import MonthYearPicker from "../../Payments/Mobile-and-Tablet/MonthPicker.jsx";
import RecentPaymentsCards from "./RecentPaymentsCards";
import PendingIncoicesCard from "./PendingIncoicesCard";
import TenantsList from "../../Tenants/Mobile-and-Tablet/TenantsList";
import TenantModificationModal from "./TenantModal.jsx";

//icons
import Card from "../../../Caretaker-Components/OverView/Mobile-and-Tablet/Card";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getAllProperties } from "../../../../redux/slices/sliceActions";

//import context
import { MyContext } from "../../../../tenantsDashContext";

const MiddleSectionOverview = () => {
  //redux methods
  const dispatch = useDispatch();
  //methods to fetch data
  useEffect(() => {
    dispatch(getAllProperties());
  }, []);

  //data fetched from the store
  const { user, properties } = useSelector((state) => state.landlordslice);

  //current property selected in context
  const [currentProperty, setCurrentProperty] = useState(null);

  useEffect(() => { 
    if (properties.length > 0) {
      setCurrentProperty(properties[0]);
    }
  }, [properties]);

  useEffect(() => {
    console.log("current property", currentProperty);
  }, [currentProperty]);

  //modal state management
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("");
  const [tenantData, setTenantData] = useState({});

  const handleShowModal = (actionType) => {
    setAction(actionType);
    setShowModal(true);
  };

  //state management
  const [seeMoreClicked, setSeeMoreClicked] = useState(false);
  const [currentSelected, setCurrentSelected] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);

  //sub-components

  // Array of tenant objects
  const tenants = [
    {
      name: "Timothy Ndiritu",
      dateJoined: "April 2024",
      apartmentNumber: "a15",
    },
    { name: "John Doe", dateJoined: "March 2024", apartmentNumber: "b10" },
    { name: "Jane Smith", dateJoined: "February 2024", apartmentNumber: "c20" },
  ];

  return (
    <div className="mid-section-mobile-caretaker">
      <div className="title-date-and-property">
        <div className="title">Reports</div>
        <div className="date-and-property">
          <MonthYearPicker />
          <div className="apartment">
            <select
              id="apartment-select"
              name="apartment"
              className="apartment-dropdown"
              onChange={(e) => {
                setCurrentProperty(e.target.value);
              }
              }
            >
              {/* map through property names and set them as options */}
              {properties.map((property) => (
                <option value={property}>{property.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="cards-slider">
        <Card setCurrentSelected={setCurrentSelected} />
      </div>
      {currentSelected === 0 && (
        <>
          <div className="recentPaymentsSection">
            <div className="title">Recent Payments</div>
            <div className="payment-list">
              <RecentPaymentsCards />
            </div>
          </div>
        </>
      )}
      {currentSelected === 1 && (
        <>
          <div className="recent-enlistings-section">
            <div className="title">Recent Enlistings</div>
            <div className="tenants-list">
              <TenantsList
                handleShowModal={handleShowModal}
                setTenantData={setTenantData}
              />
            </div>
          </div>
        </>
      )}

      {currentSelected === 2 && (
        <>
          <div className="recentPaymentsSection">
            <div className="title">Pending Invoices</div>
            <div className="payment-list">
              <PendingIncoicesCard />
            </div>
          </div>
        </>
      )}

      {showModal && (
        <TenantModificationModal
          setShowPay={setShowModal}
          fieldToShow={action}
          tenantData={tenantData}
        />
      )}
    </div>
  );
};

export default MiddleSectionOverview;
